import script from "./JigsawNodeToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./JigsawNodeToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./JigsawNodeToolbar.vue?vue&type=style&index=0&id=81e35e40&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81e35e40"]])

export default __exports__